import { render, staticRenderFns } from "./ProfileCustomizer.vue?vue&type=template&id=62b9d60e&scoped=true&"
import script from "./ProfileCustomizer.vue?vue&type=script&lang=js&"
export * from "./ProfileCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCustomizer.vue?vue&type=style&index=0&id=62b9d60e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b9d60e",
  null
  
)

export default component.exports